import { SharedProgrammingService } from './../../common/services/shared-programming.service';
import { ProgrammingEventService } from './../../common/services/event.service';
import { Type, OnInit, OnChanges, Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'prg-select-event',
  templateUrl: './select-event.html',
  styleUrls: [
    './select-event.css'
  ],
  providers: []
})
export class SelectEventComponent {

  events: Observable<Array<any>>;

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private eventService: ProgrammingEventService
  ) {
    this.events = this.store.select(s => s.advancedProgramming.event.events);
  }

  ngOnInit() {
  }

  private eventSelected(event: any) {
    if (event) {
      this.eventService.selectEvent(event).then(
        res => {
          this.router.navigate(['../device', event.deviceId, 'event', event.eventId], { relativeTo: this.route });
        },
        err => {
          console.warn('sel-evt: error selecting event', event, err);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-event/select-event.ts